module.exports = __webpack_public_path__ + "static/media/FSL_intro.7941a008.png";